<div id="pedidoLiberar" class="modal modal-full-width fade" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Atualizar dados de internet do cliente
                </h4>        
                <small *ngIf="isLoadingCliente">
                    <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i>
                </small>
                <small *ngIf="!isLoadingCliente">
                    Cliente: {{cliente?.pessoa?.codigoIntegracaoErp}} - {{getNomeCliente()}}
                    <p>CNPJ / CPF: {{cliente?.pessoa?.cnpjCpf}}</p>
                </small>                
            </div>
            <div class="modal-body">
                <p *ngIf="isLoading" class="is-loading-msg">
                    <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando
                </p>

                <!-- Form -->
                <span *ngIf="!isLoading && entity !== null && entity !== undefined">
                    <sgt-cliente-internet-form
                        #form
                        [canEdit]="config?.canEdit"
                        [entity]="entity"
                        [(site)]="entity.site">
                    </sgt-cliente-internet-form>  
                </span>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="update()" id="btnUpdateClienteInternet">
                    Atualizar
                </button>              
                <button type="button" class="btn btn-light" (click)="close()">
                    Não Atualizar
                </button>
            </div>            
        </div>
    </div>
</div>